import { useQuery } from '@apollo/client';
import { useBrand } from '../brand';
import { GET_DAY_AGREEMENT } from './queries';
import type { DayAgreement } from './lib';

/** The day's agreement-mark record (Prime Pick / Platinum Edge winners) for the Today so far tiles, and a way to refresh it. */
export function useDayAgreement(date: string, skip = false): { agree: DayAgreement | undefined; refetch: () => unknown } {
  const { markName } = useBrand();
  const q = useQuery<{ consensusPickStats: { rows: { trackType: string; agreeRaces: number; agreeWins: number; agreeRoi: number | null }[] } | null }>(GET_DAY_AGREEMENT, {
    variables: { date },
    errorPolicy: 'all',
    skip,
  });
  const total = q.data?.consensusPickStats?.rows.find((r) => r.trackType === 'total');
  return { agree: total ? { markName, wins: total.agreeWins, races: total.agreeRaces, roi: total.agreeRoi } : undefined, refetch: q.refetch };
}
